import { render } from "./deptCard.vue?vue&type=template&id=6743c55a&scoped=true"
import script from "./deptCard.vue?vue&type=script&lang=js"
export * from "./deptCard.vue?vue&type=script&lang=js"

import "./deptCard.vue?vue&type=style&index=0&id=6743c55a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6743c55a"]])

export default __exports__